import {Button, Header, Pagination, TableSkeleton} from '@/components';

import TestTransactionFilters from './TestTransactionFilters';
import TestTransactionTable from './TestTransactionTable';
import {PAGE_SIZE} from './types';
import useTestTransactionList from './useTestTransactionList';

const TestTransactionList = () => {
  const {
    error,
    isLoading,
    total,
    transactionList,
    filterKey,
    onPageChange,
    retry,
    filterCount,
    currentFilters,
    filtersToApply,
    clearFilters,
    selectAppliedFilters,
    handleApplyFilters,
    selectCurrentFilters,
  } = useTestTransactionList();
  const countSuffix = total > 0 ? `(${total.toLocaleString()})` : '';

  // Same branch order as the retail list: a failed request leaves the list at
  // [], so the error arm sits ahead of the table.
  const renderContent = () => {
    if (isLoading) {
      return <TableSkeleton />;
    }
    if (error) {
      return (
        <div className="text-red-500">
          Failed to load test transactions.{' '}
          <Button variant="ghost" onClick={retry}>
            Retry
          </Button>
        </div>
      );
    }
    return <TestTransactionTable items={transactionList} />;
  };

  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={`Test Transactions ${countSuffix}`} />

      <TestTransactionFilters
        filterCount={filterCount}
        currentFilters={currentFilters}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
        selectCurrentFilters={selectCurrentFilters}
      />

      <section className="pt-5 md:pt-5">{renderContent()}</section>

      {total > PAGE_SIZE ? (
        <Pagination
          key={filterKey}
          limit={PAGE_SIZE}
          onPageChange={onPageChange}
          total={total}
        />
      ) : null}
    </main>
  );
};

export default TestTransactionList;
